var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{staticClass:"custom-tooltip",on:{"click":function($event){return _vm.copyToClipboard(_vm.text)}}},[_c('div',{class:_vm.$style.textWrapper},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('font-awesome-icon',{attrs:{"icon":"clone"}})],1),(_vm.tooltip)?_c('div',{staticClass:"tooltip"},[_vm._v(" Copied! ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }